<template>
  <section>
    <nav-component :titulo="'Editar almacén'" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item tag='router-link' to="/almacenes">Almacenes</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar almacén</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="box">
      <b-field label="Nombre del almacén">
        <b-input placeholder="Nombre" v-model="almacen.nombre"></b-input>
      </b-field>

      <b-field label="Encargado">
        <b-input placeholder="Nombre del encargado" v-model="almacen.encargado"></b-input>
      </b-field>

      <b-field label="Código (máx 3 dígitos)">
        <b-input placeholder="Código" v-model="almacen.cod" maxlength="3" minlength="1"></b-input>
      </b-field>

      <b-field label="Color referencial">
        <b-input type="color" v-model="almacen.color"></b-input>
      </b-field>

      <div class="buttons">
        <b-button type="is-primary" size="is-large" icon-left="check" @click="editar">Guardar</b-button>
        <b-button type="is-dark" size="is-large" icon-left="cancel" tag="router-link" to="/almacenes">Cancelar</b-button>
      </div>
    </div>
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import NavComponent from '../Extras/NavComponent.vue'

export default {
  name: "EditarAlmacen",
  components: { NavComponent },

  data: () => ({
    cargando: false,
    almacen: {
      id: null,
      nombre: '',
      encargado: '',
      cod: '',
      color: '#2196F3',
    },
  }),

  mounted() {
    const id = this.$route.params.id
    this.cargando = true
    HttpService.obtenerConConsultas('almacenes.php', { accion: 'obtener_por_id', id })
      .then(resultado => {
        this.almacen = resultado
        this.cargando = false
      })
      .catch(() => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Error al cargar almacén.' })
        this.cargando = false
      })
  },

  methods: {
    editar() {
      if (!this.almacen.nombre || !this.almacen.encargado || !this.almacen.cod) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Completa todos los campos obligatorios.' })
        return
      }

      this.cargando = true
      HttpService.editar('almacenes.php', { accion: 'editar', almacen: this.almacen })
        .then(() => {
          this.$buefy.toast.open({ type: 'is-info', message: 'Almacén editado con éxito.' })
          this.$router.push('/almacenes')
        })
        .catch(() => {
          this.$buefy.toast.open({ type: 'is-danger', message: 'Error al editar almacén.' })
          this.cargando = false
        })
    }
  }
}
</script>